export const ORDER_STATUSES = {
    CREATED: 'C',
    UNPROCESSED: 'U',
    SHIPMENT_CREATED: 'P',
    ON_HOLD: 'H',
    DELIVERED: 'D',
    UN_KNOWN: 'UNKWN',
};
